<template>
  <div>
    <b-overlay
      :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
      <div
        v-if="['jpg', 'png', 'gif', 'jpeg', 'webp'].includes(dataImage.extension ? dataImage.extension : dataImage.name)"
        class="h-50 p-2"
      >
        <img
          :src="dataImage.full_path ? dataImage.full_path : dataImage.file_local"
          class="img-fluid"
        >
      </div>
      <div
        v-else
        class="video p-1"
      >
        <video
          width="100%"
          poster="/img/poster.gif"
          :src="link"
          autoplay
          controls
          type="video/*"
        />
        <!-- <b-button
          v-if="extension.includes('mp3', 'wav', 'm4a')"
          variant="danger"
          class="mt-1 btn-sm"
          @click="speechToText(link, file_id)"
        >Chuyển sang văn bản</b-button> -->
      </div>
    </b-overlay>
  </div>
</template>
<script>

import {
  BCard, BRow, BCol, BImg, BButton, BOverlay,
} from 'bootstrap-vue'
import {
  ref, watch, computed,
} from '@vue/composition-api'
import store from '@/store'
import { showToast } from '@/@core/utils/utils'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BImg,
    BButton,
    BOverlay,
  },
  props: {
    dataImage: {
      type: Object,
      default: null,
    },
  },
  setup(props, context) {
    const link = ref('')
    const extension = ref('')
    const loading = ref(false)
    const file_id = ref('')
    if (Object.keys(props.dataImage).length > 0) {
      // link.value = props.dataImage.full_path ? props.dataImage.full_path : props.dataImage.response.data.full_path
      link.value = props.dataImage.full_path ? props.dataImage.full_path : props.dataImage.file_local
      extension.value = props.dataImage.extension
      file_id.value = props.dataImage.file_id ? props.dataImage.file_id : props.dataImage.id
      // console.log('extension', extension.value)
    }
    return {
      link,
      loading,
      extension,
      file_id,
    }
  },
  methods: {
    speechToText(link, file_id) {
      this.loading = true
      store.dispatch('article/speechToText', { file_path: link, file_id })
        .then(response => {
          const result = response.data;
          this.loading = false
          if (result.code == 200) {
            const content = result.data
            this.$emit('updateSpeechToText', content)
          } else {
            showToast(result.message);
          }
        })
    },
  },
}
</script>
<style lang="scss"></style>
